import { Injectable } from '@angular/core';
import { DoenKidsGenericApiProvider } from 'src/providers/generic.provider';
import { SortDirection } from '@angular/material/sort';
import { IActivityKindListResponse } from 'typings/api-activity';
import { ActivityKindStore } from './activity-kind.store';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivityKindService {
  constructor(private store: ActivityKindStore, private $baseApi: DoenKidsGenericApiProvider) {}

  async fetchAll(limit: number = 100, skip: number = 0, sortField: string = 'created_at', sortDirection: SortDirection = 'desc') {
    const ageGroupListRepsonse = await firstValueFrom(this.$baseApi.genericListCall('/activity/activity-kind', limit, skip, sortField, sortDirection)) as IActivityKindListResponse;

    this.store.set(ageGroupListRepsonse?.items ?? []);
    return ageGroupListRepsonse;
  }
}
